import { Alert, AlertIcon, Text } from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'
import { getScheduledWithdrawTimes } from 'services/api.service'
import { DateTime } from 'luxon'

function getNextScheduledTime(times: string[]): string | null {
  if (!times.length) return null

  const now = DateTime.now().setZone('America/Sao_Paulo')
  const currentMinutes = now.hour * 60 + now.minute

  const sorted = [...times].sort()

  for (const time of sorted) {
    const [h, m] = time.split(':').map(Number)
    if (h * 60 + m > currentMinutes) {
      return DateTime.now()
        .setZone('America/Sao_Paulo')
        .set({ hour: h, minute: m, second: 0 })
        .plus({ hours: 2 })
        .toFormat('HH:mm')
    }
  }

  // All times have passed today — next is tomorrow's first time + 2h
  const [h, m] = sorted[0].split(':').map(Number)
  return DateTime.now()
    .setZone('America/Sao_Paulo')
    .plus({ days: 1 })
    .set({ hour: h, minute: m, second: 0 })
    .plus({ hours: 2 })
    .toFormat('HH:mm')
}

export default function ScheduledWithdrawalAlert() {
  const { data: times } = useQuery({
    queryKey: ['scheduledWithdrawTimes'],
    queryFn: getScheduledWithdrawTimes,
    staleTime: 5 * 60 * 1000,
  })

  if (!times || times.length === 0) return null

  const previsao = getNextScheduledTime(times)
  if (!previsao) return null

  return (
    <Alert status="info" borderRadius="md" mb={4}>
      <AlertIcon />
      <Text fontSize="sm">
        Previsão de processamento do saque até <b>{previsao}</b>.
      </Text>
    </Alert>
  )
}
